import { defineMessages } from 'react-intl';

const messages = defineMessages({
  header: {
    id: 'rewards.partnerships.header',
    description: 'Partnerships section header',
    defaultMessage: 'Partnerships',
  },
  subHeading: {
    id: 'rewards.partnerships.subHeading',
    description: 'Partnerships section sub heading',
    defaultMessage:
      "The Rewards don't stop at your morning coffee. <link>Join Starbucks® Rewards</link> and unlock perks from our partners, all while earning more Stars.",
  },
  aeroplanDescription: {
    id: 'rewards.partnerships.aeroplanDescription',
    description: 'Air Canada content',
    defaultMessage:
      'Link your Aeroplan and Starbucks® Rewards accounts to unlock exclusive offers and earn Aeroplan points when you reload funds in the Starbucks app.{disclaimerTarget}',
  },
  bankOfAmericaDescription: {
    id: 'rewards.partnerships.bankOfAmericaDescription',
    description: 'Bank of America content',
    defaultMessage:
      'Link your eligible Bank of America card to earn 2% Cash Back and Bonus Stars on in-app purchases.{disclaimerTarget}',
  },
  deltaSkymilesDescription: {
    id: 'rewards.partnerships.deltaSkymilesDescription',
    description: 'Delta Skymiles content',
    defaultMessage:
      'Link your Delta Skymiles to earn miles on Starbucks Card reloads of $25 or more, plus Double Stars on travel days.{disclaimerTarget}',
  },
  tdBankDescription: {
    id: 'rewards.partnerships.tdBankDescription',
    description: 'TD Bank content',
    defaultMessage:
      'Link your eligible TD Credit or Visa Debit Card and Starbucks® Rewards account to earn 50% more Stars when you order in the Starbucks app at participating Starbucks locations.{disclaimerTarget}',
  },
  marriottDescription: {
    id: 'rewards.partnerships.marriottDescription',
    description: 'Marriott content',
    defaultMessage:
      'Link your Marriott Bonvoy to earn Double Stars on eligible stays, points during Bonvoy Week, and more.{disclaimerTarget}',
  },
});

export default messages;
